import { TimeFormatOptions } from '@griply/types';
import { format } from 'date-fns';

const MERIDIEM_PATTERN = 'a';
const TIME_WITHOUT_MERIDIEM_PATTERN = 'h:mm';

export const formatTimeRange = (
  start: Date,
  end: Date,
  timeFormat: TimeFormatOptions,
): string => {
  const sharesMeridiem =
    timeFormat === TimeFormatOptions.Standard &&
    format(start, MERIDIEM_PATTERN) === format(end, MERIDIEM_PATTERN);

  const startLabel = format(
    start,
    sharesMeridiem ? TIME_WITHOUT_MERIDIEM_PATTERN : timeFormat,
  );

  return `${startLabel}-${format(end, timeFormat)}`;
};
